import { render } from "./FeaturedProducts.vue?vue&type=template&id=677e27b3&scoped=true"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"

import "./FeaturedProducts.vue?vue&type=style&index=0&id=677e27b3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677e27b3"]])

export default __exports__